import { ReactionsOnEntity } from "@backend/reaction/types";

export function totalReactionCount(reactions: ReactionsOnEntity): number {
    return Object.values(reactions).reduce((sum, reactionCount) => sum + reactionCount, 0);
}
